import React from "react";

/* ---------- Icons ---------- */

export default function CameraIcon({ size = 16, color = "currentColor" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.75" width={size} height={size}>
      <path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h1.9l1.4-1.7A1 1 0 0 1 9.6 4h4.8a1 1 0 0 1 .8.4L16.6 6h1.9A2.5 2.5 0 0 1 21 8.5v9A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-9Z" />
      <circle cx="12" cy="13" r="3.5" />
    </svg>
  );
}
